module.exports = __webpack_public_path__ + "assets/insided.f224b1d0.svg";